import { AppThunk } from 'redux/reducers/rootReducer';
import { setFetchOrderDocumentsPending, setFetchOrderDocumentsSucces, setFetchOrderDocumentsError, initialState } from 'redux/reducers/data_action_reducers/orders/orderDocumentsReducer';
import { ITableData } from 'types/backend_models/shared/ITableData';
import { IDocument } from 'types/backend_models/documents/IDocument';
import { IGenericDataFetchParams, createGenericDataFetch } from '../generic/GenericDataActions';

const defaultQueryData = {
	sorted: '',
	filters: [],
	currentPage: initialState.data.currentPage,
	pageSize: initialState.data.pageSize
}

const documentOwnerTypeIdOrder = 6;

var fetchParams: IGenericDataFetchParams<ITableData<IDocument[]>> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchOrderDocumentsPending,
	succesActionCreator: setFetchOrderDocumentsSucces,
	errorActionCreator: setFetchOrderDocumentsError
}

/** Fetches documents related to an order */
export function fetchOrderDocuments(orderId: number): AppThunk
{

	let filters = `documentownertypeid==${documentOwnerTypeIdOrder}, documentownerid==${orderId}`;
	const query = `?Page=${defaultQueryData.currentPage}&PageSize=${defaultQueryData.pageSize}&filters=${filters}`;
	fetchParams.apiEndPoint = `customer/documents${query}`;

	return createGenericDataFetch<ITableData<IDocument[]>>(fetchParams);
}